$('body').on('click', '.open-view-photo-album-image', function () {
    var $this = $(this);
    slideSlide($('.photo-album-image-viewer .slider'), $this.index());
    $('.photo-album-image-viewer').addClass('visible');
    return false;
});

$('body').on('click', '.photo-album-image-viewer .close', function () {
    $('.photo-album-image-viewer').removeClass('visible');
    return false;
});

$(document).keyup(function (e) {
    if (e.keyCode === 27) { // Esc
        $('.photo-album-image-viewer').removeClass('visible');
    }

    if (e.keyCode === 37 && $('.photo-album-image-viewer').hasClass('visible')) {
        $('.photo-album-image-viewer .slide-navigation[data-direction="previous"]').trigger('click');
    }

    if (e.keyCode === 39 && $('.photo-album-image-viewer').hasClass('visible')) {
        $('.photo-album-image-viewer .slide-navigation[data-direction="next"]').trigger('click');
    }
});